import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HomeService } from '../../home/home.service';
import { Observable } from 'rxjs';
import { resturlConstants } from '../../../rest-url/resturlconstants';
import { environment } from '../../../environments/environment';

@Injectable()
export class DailyDepositsService {


  constructor(private http: HttpClient, private homeService: HomeService) { }

  dailyDepositData(): Observable<any> {
    return this.http.post<any>(resturlConstants.DDUrl, {
      'userId': localStorage.getItem('userId'),
      'clientShortCode': environment.clientShortCode
    },
      {
        headers: new HttpHeaders()
          .set('Content-type', 'application/JSON')
          .set('Authorization', this.homeService.getAuthHeader())
      });
  }

}
